import React, { useState, useEffect } from 'react';
import content from '../data/content';

export default function ImpressumPage() {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="section" style={{ paddingTop: 120 }}>
      <div className="container">
        <div className="section-header">
          <span className="section-label">Rechtliches</span>
          <h2 className="section-title">Impressum</h2>
        </div>
        <div className="impressum-content">
          <div className="impressum-intro">{content.impressum.intro}</div>

          <h2 className="section-title" style={{ fontSize: '1.8rem', marginBottom: 24 }}>
            Datenschutzerklärung
          </h2>
          <div className="accordion">
            {content.impressum.datenschutz.map((item, index) => (
              <div key={index} className="accordion-item">
                <div className="accordion-header" onClick={() => toggle(index)}>
                  {item.title}
                  <span className={`accordion-chevron ${openIndex === index ? 'open' : ''}`}>
                    ▼
                  </span>
                </div>
                {openIndex === index && (
                  <div className="accordion-body">{item.content}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
